<!---===================== MODAL FOR ADD NEW FIN =====================--->
<section (click)="VerifySweetAlert()" class="Modal-Global" id="ModalAddFIN">

  <div class="wrapper">
    <div class="Pro-popupFIN1-Temp popup">
      <div class="Pro-insideFIN1-Temp popup-inside">
        <div class="Pro-backgroundsFIN1-Temp backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="FormFIN" (submit)="ValidToogleFIN()">
        <div class="Pro-contentFIN1-Temp content">
          <button type="button" id="Btn-Close-Add-Top" class="Btn-Close" (click)="ToggleModalAddFIN(false)"><i
              class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Cargar nuevo Proceso</h2>
          </div>

          <div class="Content-body modal-body-scroll">

            <!-- ====== SECCION: DOCUMENTO ====== -->
            <div class="modal-section-label">Documento</div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Archivo del Proceso
              </div>
              <div class="Container-input InputFile" id="IdInputFileNewFIN">
                <div class="IputFileleft">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivo</div><input #AddFile (change)="AddDocument($event)" type="file"
                    name="">
                </div>
                <div class="Name-File">
                  {{CutNameFile(this.FileAuxAddFIN.FileName,20)}}
                </div>
              </div>
            </div>
            <div class="Content-grid-2">
              <div class="Text-icon">
                OCR Local
              </div>
              <div class="Container-input-switch">
                <div class="switch-container" [class.active]="UseOCR_Local" (click)="ToggleOCR_Local()">
                  <div class="switch-label">
                    <i [class]="UseOCR_Local ? 'fa-solid fa-server' : 'fa-solid fa-circle-exclamation'"></i>
                    <span>{{ UseOCR_Local ? 'Local Activo' : 'Local Desactivado' }}</span>
                  </div>
                  <div class="switch-button">
                    <div class="handle"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                OCR Cloud
              </div>
              <div class="Container-input-switch">
                <div class="switch-container" [class.active]="UseOCR_Cloud" (click)="ToggleOCR_Cloud()">
                  <div class="switch-label">
                    <i [class]="UseOCR_Cloud ? 'fa-solid fa-cloud' : 'fa-solid fa-circle-exclamation'"></i>
                    <span>{{ UseOCR_Cloud ? 'Cloud Activo' : 'Cloud Desactivado' }}</span>
                  </div>
                  <div class="switch-button">
                    <div class="handle"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-or-divider" *ngIf="FormTemplates.length > 0">
              <span>o usa un formulario</span>
            </div>

            <div class="Content-grid-2" *ngIf="FormTemplates.length > 0">
              <div class="Text-icon">
                Formulario
              </div>
              <div class="Container-input">
                <p-select [options]="FormTemplates" optionLabel="Name" [(ngModel)]="SelectedFormTemplateOption"
                  [ngModelOptions]="{standalone: true}" (onChange)="OnFormTemplateSelect($event)"
                  placeholder="Seleccione un formulario (opcional)" [showClear]="true" styleClass="w-full">
                </p-select>
              </div>
            </div>

            <!-- Action Card: Llenar / Completado -->
            <div *ngIf="SelectedFormTemplate" class="form-action-card" [ngClass]="{'card-completed': IsFormCompleted}"
              (click)="OpenFormModal()">
              <div class="form-card-icon">
                <i [class]="IsFormCompleted ? 'fa-solid fa-circle-check' : 'fa-regular fa-file-lines'"></i>
              </div>
              <div class="form-card-body">
                <span class="form-card-title">{{ IsFormCompleted ? 'Formulario completado' : 'Formulario pendiente'
                  }}</span>
                <span class="form-card-subtitle">{{ SelectedFormTemplate.Name }} · {{ GetTotalFieldCount() }}
                  campos</span>
              </div>
              <div class="form-card-action">
                <span>{{ IsFormCompleted ? 'Editar' : 'Llenar' }}</span>
                <i class="fa-solid fa-arrow-right"></i>
              </div>
            </div>

            <!-- ====== SECCION: DATOS DEL PROCESO ====== -->
            <div class="modal-section-label">Datos del proceso</div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Código del Proceso
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-qrcode"></i><input id="IdinputCodeOf_FIN" type="text" formControlName="Code"
                  placeholder="Código…" [class.Is-Disabled]="ShouldDisableFields()"
                  [appFormFINDisabled]="ShouldDisableFields()">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Objetivo del Proceso
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-regular fa-message"></i><input id="IdinputDescripFIN" type="text" formControlName="Purpose"
                  placeholder="Objetivo del Proceso (Purpose)…" [class.Is-Disabled]="ShouldDisableFields()"
                  [appFormFINDisabled]="ShouldDisableFields()">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                No. revisión
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-hashtag"></i><input id="IdinputNoRevisFIN" type="number" min="1" max="99"
                  formControlName="Revision_No" placeholder="No. revisión …" [class.Is-Disabled]="ShouldDisableFields()"
                  [appFormFINDisabled]="ShouldDisableFields()">
              </div>
            </div>

            <!-- ====== SECCION: REVISORES ====== -->
            <div class="modal-section-label" *ngIf="VisibleReviewers.length > 0">Revisores</div>

            <div class="Content-grid-2"
              *ngFor="let reviewerSlot of VisibleReviewers; let i = index; trackBy: TrackByReviewerSlot">
              <div class="Text-icon">
                {{GetReviewerLabel(reviewerSlot)}}
              </div>
              <div class="Container-input Reviewer-Container" [class.Is-Disabled]="ShouldDisableFields()">
                <div class="Input-Autocomplete Reviewer-Input">
                  <i class="fa-regular fa-user"></i>
                  <ng-autocomplete *ngIf="RenderReviewerAutocomplete" class="ng-autocomplete"
                    [data]="GetReviewerUsers(reviewerSlot)" id="IdInputAuA{{reviewerSlot}}NewFIN" [initialValue]=""
                    [placeholder]="'Buscar ' + GetReviewerLabel(reviewerSlot)" searchKeyword="Name"
                    notFoundText="Usuario no encontrado" [itemTemplate]="itemTemplateReviewers"
                    [notFoundTemplate]="notFoundReviewers" [formControlName]="GetApproverControlName(reviewerSlot)"
                    (inputFocused)="OnReviewerAutocompleteFocus(reviewerSlot)"
                    (click)="OnReviewerAutocompleteHostClick($event, reviewerSlot)"
                    [class.Is-Disabled]="ShouldDisableFields()" [class.Is-Warning]="UserIsReplicated(reviewerSlot - 1)">
                  </ng-autocomplete>

                  <ng-template #itemTemplateReviewers let-item>
                    <a [innerHTML]="item.Name"></a>
                  </ng-template>

                  <ng-template #notFoundReviewers let-notFound>
                    <div [innerHTML]="notFound"></div>
                  </ng-template>
                </div>
              </div>
            </div>

            <!-- ====== SECCION: ANEXOS ====== -->
            <div class="modal-section-label">Anexos</div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Anexos relacionados
              </div>
              <div class="Container-input InputFile" [class.Is-Disabled]="ShouldDisableFields()">
                <div class="IputFileleft" [class.Is-Disabled]="ShouldDisableFields()">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivos</div><input #AddFileAnnexe type="file" name=""
                    (change)="Add_Document_Annexe($event)" [disabled]="ShouldDisableFields()">
                </div>
              </div>
            </div>

            <div class="Content-grid-2 Container-Annexes" *ngIf="FileAuxAddFIN_Annexes.length > 0">
              <div class="Not-Annexes">
              </div>
              <div class="Container-Card-Annexes">
                <div *ngFor="let Annexe of FileAuxAddFIN_Annexes" class="Card-Annexes">

                  <div class="Container-File">
                    <ng-container *ngFor="let icon of Icons_Image">
                      <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                        <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                      </div>
                    </ng-container>
                    <div class="Name-Annexe">
                      {{CutNameFile(Annexe.FileName,40)}}
                    </div>
                  </div>

                  <div (click)="Delete_Annexe(Annexe.FileName)" class="Delete-Annexe button-square">
                    <i class="fa-solid fa-xmark"></i>
                  </div>

                </div>

              </div>

            </div>

          </div>

          <div class="Container-Progress" id="Content-Progress">
            <div class="ProgressBar" id="Progress-Bar"></div>
          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form Btn-Save-Modal" id="BtnSavedFIN"
              [disabled]="IsLoadingReviewers">
              <i class="icon-send material-icons" id="Send-Icon">{{GetSubmitButtonIcon()}}</i>
              <i class="icon-check material-icons" id="Check-Icon">check</i>
              <span class="Btn-Save-Modal-text" id="Text-Btn">{{GetSubmitButtonText()}}</span>
            </button>
            <button type="button" id="Btn-Close-Add-Bottom" (click)="ToggleModalAddFIN(false)"
              class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </button>

          </div>

        </div>
      </form>
    </div>
  </div>

  <div class="Sweet-Alert" id="Sweet_Alert">
    <div class="Sweet-Alert--Icon">
      <div class="swal2-icon swal2-question swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">?</div>
      </div>
    </div>
    <div class="Sweet-Alert--Title">
      ¿Los datos son correctos?
    </div>
    <div class="Sweet-Alert--Text">
      Si todo esta bien, presiona el botón para continuar
    </div>
    <div class="Sweet-Alert--Container-Button">
      <button (click)="Sweet_Alert_Send_New_FIN()" class="Sweet-Alert--Container-Button--Button btn-icon-text">
        <i class="fa-solid fa-check-double"></i> <span>Sí, son correctos</span>
      </button>
      <button (click)="Toggle_Modal_Sweet_Alert_SendFIN(false)"
        class="Sweet-Alert--Container-Button--Button Cancel btn-icon-text">
        <span>Cancel</span>
      </button>
    </div>
  </div>

</section>

<!---===================== MODAL FOR NOTIFICATION GROUPS FIN =====================--->
<section class="Modal-Global" id="ModalNotificationFIN">
  <div class="wrapper">
    <div class="Pro-popupNotFIN1 popup">
      <div class="Pro-insideNotFIN1 popup-inside">
        <div class="Pro-backgroundsNotFIN1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-contentNotFIN1 content">
        <div class="Btn-Close"></div>
        <div class="Content-Top">
          <h2>Notificar a grupos</h2>
        </div>

        <div class="Container-Body-Notification Content-body">


          <ng-container *ngIf="Group_Notification.length>0 else Not_Groups">
            <div *ngFor="let group of Group_Notification;let i = index" class="Container-Grid-Local Content-grid-2">
              <div class="Container-input Input-CheckBox">
                <input type="checkbox" id="CheckBox{{i}}" class="ui-checkbox">
              </div>
              <div class="Text-icon">
                {{group.Name}}
              </div>
            </div>
          </ng-container>

          <ng-template #Not_Groups>
            <div class="Not-Groups">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Mail_Groups.png" alt="">
              </div>
              <div class="Text-Not-Groups">
                No existen grupos de notificación para cargas de Procesos.
              </div>
            </div>
          </ng-template>

        </div>
        <div class="Content-Bottom">
          <button (click)="SavedNewFIN()" class="Btn-LSave-Form Btn-Save-Modal">
            <i class="Icon-Two fa-regular fa-bell"></i>
            <span class="Btn-Save-Modal-text" id="Text-Btn">Guardar</span>
          </button>

        </div>
      </div>
    </div>
  </div>
</section>
